import { render } from "./MediaObject.vue?vue&type=template&id=aed86870"
import script from "./MediaObject.vue?vue&type=script&lang=js"
export * from "./MediaObject.vue?vue&type=script&lang=js"

import "./MediaObject.vue?vue&type=style&index=0&id=aed86870&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__